interface RoomSizeSettings {
  value: { size: number; maxParticipants: number };
  label: string;
  checked: boolean;
}

type OldRoomSizeSettings = RoomSizeSettings;
type NewRoomSizeSettings = RoomSizeSettings;
// TODO: This should be data driven, values in table SocialRoomLimit
export const newRoomSizeSettings: NewRoomSizeSettings[] = [
  { value: { size: 2000, maxParticipants: 10 }, label: 'Mini - maximum 10 attendees', checked: false },
  { value: { size: 4000, maxParticipants: 25 }, label: 'Small - maximum 25 attendees', checked: false },
  { value: { size: 8000, maxParticipants: 75 }, label: 'Medium - maximum 75 attendees', checked: false },
  {
    value: { size: 12000, maxParticipants: 125 },
    label: 'Large - maximum 125 attendees',
    checked: false,
  },
  {
    value: { size: 16000, maxParticipants: 200 },
    label: 'Extra Large - maximum 200 attendees',
    checked: false,
  },
  {
    value: { size: 20000, maxParticipants: 300 },
    label: 'Jumbo -  maximum 300 attendees',
    checked: false,
  },
];

export const oldRoomSizeSettings: OldRoomSizeSettings[] = [
  { value: { size: 4000, maxParticipants: 25 }, label: 'Small - maximum 25 attendees', checked: false },
  {
    value: { size: 12000, maxParticipants: 50 },
    label: 'Medium - maximum 50 attendees',
    checked: false,
  },
  { value: { size: 16000, maxParticipants: 75 }, label: 'Large - maximum 75 attendees', checked: false },
  {
    value: { size: 20000, maxParticipants: 300 },
    label: 'Extra Large - maximum 300 attendees',
    checked: false,
  },
];
